export default "__VITE_ASSET__BLOHCm0r__"